import PresentationPreview from './PresentationPreview';
import CreatePresentation from './CreatePresentation';

const presentation = {
  type: 'presentation',
  name: 'Presentations',
  icon: 'document',
  Preview: PresentationPreview,
  Create: CreatePresentation
};

export default presentation;
